const ASSET_STATUS_TO_STYLE = {
    stopped: {
        color: 'secondary',
        backgroundClass: 'background-grey',
        label: 'Shutdown',
        icon: 'fa-solid fa-circle-pause'
    },
    in_downtime: {
        color: 'negative',
        backgroundClass: 'background-red',
        label: 'Asset down',
        icon: 'fa-solid fa-circle-xmark'
    },
    running: {
        color: 'positive',
        backgroundClass: 'background-green',
        label: 'Running',
        icon: 'fa-solid fa-circle-play'
    },
    changeover: {
        color: 'dark-yellow',
        backgroundClass: 'background-yellow',
        label: 'Switch',
        icon: 'fa-solid fa-sync-alt'
    },
    unknown: {
        color: 'secondary',
        backgroundClass: 'background-grey',
        label: 'Loading...',
        icon: ''
    },
    disconnected: {
        color: 'secondary',
        backgroundClass: 'background-grey',
        label: 'Disconnected',
        icon: 'fa-solid fa-ban'
    }
};

const STATUS_OPTIONS = [
    {
        color: ASSET_STATUS_TO_STYLE['stopped']['color'],
        label: 'Shutdown',
        value: 'stopped'
    },
    {
        color: ASSET_STATUS_TO_STYLE['changeover']['color'],
        label: 'Switch',
        value: 'changeover'
    },
    {
        color: ASSET_STATUS_TO_STYLE['running']['color'],
        label: 'Running',
        value: 'running'
    },
    {
        color: ASSET_STATUS_TO_STYLE['in_downtime']['color'],
        label: 'Downtime',
        value: 'in_downtime'
    }
];

const SENSOR_TYPES_TO_LABELS = {
    reject: 'Reject',
    production: 'Production'
};

const getStatusOptionProperty = function (status, property) {
    for (const option of STATUS_OPTIONS) {
        if (status === option['value']) {
            return option[property];
        }
    }
};

/**
 * Minimum seconds for a phase to be splittable.
 */
const MIN_SECONDS_FOR_PHASE_SPLIT = 3;

export {
    ASSET_STATUS_TO_STYLE,
    SENSOR_TYPES_TO_LABELS,
    STATUS_OPTIONS,
    getStatusOptionProperty,
    MIN_SECONDS_FOR_PHASE_SPLIT
};
